import './bootstrap';
import $ from 'jquery';

window.$ = window.jQuery = $;

import './features/offcanvas-menu';
import './features/cookie-consent';
import './features/page-loader';
import './features/youtube-facade';
